const getSpanishRating = (rating: number): string => {
  if (rating >= 4.8) {
      return "Casi Perfecto";
  } else if (rating >= 4.5) {
      return "Excelente";
  } else if (rating >= 4.0) {
      return "Muy Bueno";
  } else if (rating >= 3.5) {
      return "Bueno";
  } else {
      return "Regular";
  }
}

export default getSpanishRating